module.exports = __webpack_public_path__ + "img/ledger.84a83f59.svg";